"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "boretto": {
    "6fe08363": [{
      "hkey": "52723cb4",
      "slug": "boretto",
      "name": "Boretto",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "52723cb4",
      "slug": "boretto",
      "name": "Boretto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cad2fcaf": [{
      "hkey": "52723cb4",
      "slug": "boretto",
      "name": "Boretto",
      "primary": true,
      "skipSearch": false
    }],
    "santa-croce": [{
      "hkey": "52723cb4",
      "slug": "boretto",
      "name": "Boretto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;